import { Country } from '~/constants/countries';
import { CountryCode, isPossiblePhoneNumber } from 'libphonenumber-js';

export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const insuranceValuesRegex = /^\d{1,5}(,\d{3})*(\.\d{0,2})?$/;

export function exists(value) {
  return !!value;
}

export function hasLength(minLength, maxLength, value) {
  if (minLength && value.length < minLength) {
    return false;
  }

  if (maxLength && value.length > maxLength) {
    return false;
  }

  return true;
}

export function isDecimal(value) {
  const decimalRegex = /^\d*\.?\d*$/;
  return decimalRegex.test(value);
}

export function isNonZero(value) {
  const nonZeroRegex = /[^0]+/;
  return nonZeroRegex.test(value);
}

export function isNIntegerPlaces(value, n) {
  const integer = Math.trunc(value);

  return integer.toString().length < n;
}

export function isNDecimalPlaces(value, n) {
  const decimalRegex = new RegExp(`^\\d*(\\.\\d{0,${n}})?$`);
  return decimalRegex.test(value);
}

export function isEmail(value) {
  return emailRegex.test(value);
}

export function isShippoEmail(email: string) {
  return email.endsWith('@shippo.com') || email.endsWith('@goshippo.com');
}

export function isValidURL(value) {
  const urlRegex =
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  return urlRegex.test(value);
}

const countryIso2ZipRegexMap = new Map([
  ['US', /^\d{5}([-]?\d{4})?$/],
  [
    'CA',
    /^([ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]) {0,1}(\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]\d)$/,
  ],
  ['MX', /^(\d{5})$/],
]);

export const isValidZipForCountry = (countryIso2, zip) => {
  if (countryIso2ZipRegexMap.has(countryIso2)) {
    const countryZipRegex = countryIso2ZipRegexMap.get(countryIso2)!;
    return countryZipRegex.test(zip);
  }
  return true;
};

export function isValidPhoneForCountry(
  phone: string | null | undefined,
  country: Country | string | null | undefined,
): boolean {
  if (!country || !phone) {
    return true;
  }

  let countryCode: string;
  if (typeof country === 'string') {
    countryCode = country;
  } else {
    countryCode = (country as Country)?.iso2;
  }

  // We use `isPossiblePhoneNumber` so someone without a phone number can enter a 555 number
  // This is necessary in cases where someone doesn't have a phone (it happens) or they are unwilling to give their number
  // Someone choosing to do this will assume the risk of an undeliverable package.
  return isPossiblePhoneNumber(phone, countryCode as CountryCode);
}
